import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from '../LanguageSwitcher';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_3885f60a-e4ce-4e7e-b71d-89edd5337d92/artifacts/2dlizjmm_Gemini_Generated_Image_1lmywa1lmywa1lmy.jpeg';

const LandingNav = ({ onLoginClick, onRegisterClick }) => {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm z-50 shadow-sm border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2" onClick={closeMobile}>
            <img
              src={LOGO_URL}
              alt="ProposAI logo"
              className="w-10 h-10 rounded-lg object-contain bg-white"
            />
            <span className="text-2xl font-bold text-primary">
              ProposAI
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center space-x-6">
            <a 
              href="#pricing" 
              className="font-medium text-sm transition-colors text-brand-ink hover:text-primary"
            >
              {t('landing.nav.pricing')}
            </a>
            <a 
              href="#how-it-works" 
              className="font-medium text-sm transition-colors text-brand-ink hover:text-primary"
            >
              {t('landing.nav.howItWorks')}
            </a>

            <LanguageSwitcher />
            
            <Button
              variant="ghost"
              onClick={onLoginClick}
              className="text-sm text-brand-ink"
              data-testid="nav-signin-btn"
            >
              {t('landing.nav.signIn')}
            </Button>
          </div>

          {/* Mobile: hamburger + language switcher */}
          <div className="md:hidden flex items-center gap-2">
            <LanguageSwitcher />
            <button
              onClick={() => setMobileOpen(o => !o)}
              className="p-2 rounded-lg transition-colors text-brand-ink"
              aria-label="Toggle menu"
              data-testid="mobile-nav-toggle"
            >
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-white shadow-lg border-t border-border">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            <a
              href="#pricing"
              onClick={closeMobile}
              className="px-3 py-2.5 rounded-lg font-medium transition-colors text-sm text-brand-ink"
            >
              {t('landing.nav.pricing')}
            </a>
            <a
              href="#how-it-works"
              onClick={closeMobile}
              className="px-3 py-2.5 rounded-lg font-medium transition-colors text-sm text-brand-ink"
            >
              {t('landing.nav.howItWorks')}
            </a>
            <div className="border-t border-border my-2" />
            <Button
              variant="ghost"
              onClick={() => { closeMobile(); onLoginClick(); }}
              className="justify-start px-3 text-sm text-brand-ink"
              data-testid="mobile-nav-signin-btn"
            >
              {t('landing.nav.signIn')}
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;
